import { getNextUuid } from '@fs/zion-sls'
import { addPlaceAndDateFieldsToFormDefaults } from '../../../../../../shared/utils/utils'
import { getEventTypeSuggestions } from './eventTypes'

export const parseEvent = ({
  event,
  types,
  t,
  selectedRelationshipPerson,
  parentRelationship,
  showRelationshipEvents,
  shouldParseEventfromSls = true,
}) => {
  if (!shouldParseEventfromSls && event) return event

  const isPrimary = event?.primary || false
  const eventTypeId = event?.id || getNextUuid()
  const eventTypeField = event?.subElements?.find((se) => se.fieldType === 'EVENT_TYPE')
  const eventTypeSuggestion = event?.eventType
    ? getEventTypeSuggestions({ types, t, isPrimary, showRelationshipEvents }).find(
        (suggestion) => suggestion.key === (event?.eventType?.key || event?.eventType)
      )
    : null

  const defaults = {
    id: eventTypeId,
    newEvent: !event?.id,
    primary: isPrimary,
    eventType: eventTypeSuggestion,
    eventTypeField: {
      ...eventTypeField,
      id: eventTypeField?.id || getNextUuid(),
      label: eventTypeSuggestion?.primaryText || t('edit-events.fields.event-type', 'Event Type'),
      fieldType: 'EVENT_TYPE',
    },
    dateFields: event?.subElements?.find((se) => se.elementType === 'DATE')?.subElements || [],
    placeFields: event?.subElements?.find((se) => se.elementType === 'PLACE')?.subElements || [],
    otherFields: event?.subElements?.filter((se) => se.elementType === 'FIELD' && se.fieldType !== 'EVENT_TYPE') || [],
    lockedChips: [],
    selectedChips: [],
    removedFields: [],
    [eventTypeId]: eventTypeSuggestion?.key,
    relationshipPerson: selectedRelationshipPerson,
    parentRelationship,
    movingPersonToOtherRecord: false,
  }

  const existingData = event?.subElements
    ?.flatMap((f) => f.subElements)
    .filter(Boolean)
    .filter((subElement) => subElement?.typeData?.editable)
    .concat(event?.subElements.filter((se) => se.elementType === 'FIELD' && se.fieldType !== 'EVENT_TYPE'))

  if (existingData?.length > 0) {
    addPlaceAndDateFieldsToFormDefaults(defaults, existingData)
  }

  return defaults
}

export const createFieldValueFromChip = ({ uuid, chip, formValues, superType }) => ({
  id: uuid || getNextUuid(),
  label: chip.label,
  fieldType: chip.value.split(':')[0],
  added: true,
  super: formValues.id,
  superType,
})
